import React, { useState, useMemo } from 'react';
import moment from 'moment';
import { Box, Typography } from '@mui/material';
import CommonFeatureIcon from '../../common/components/CommonFeatureIcon';
import { ArrowBackIosNew, ArrowForwardIos } from '@mui/icons-material';
import theme from '../../theme';

function TaskCarousel({ tasks }) {
    const [currentIndex, setCurrentIndex] = useState(0);

    // Sort tasks by due date (ascending - earliest first)
    const sortedTasks = useMemo(() => {
        if (tasks?.length > 0) {
            return [...tasks]
                .filter(task => task.is_active && task.status !== 'COMPLETED') // Optional: filter active/incomplete tasks
                .sort((a, b) => moment(a.due_date).valueOf() - moment(b.due_date).valueOf());
        }
    }, [tasks]);

    const currentTask = sortedTasks?.[currentIndex];

    const handlePrev = () => {
        setCurrentIndex(prev => (prev > 0 ? prev - 1 : sortedTasks?.length - 1));
    };

    const handleNext = () => {
        setCurrentIndex(prev => (prev < sortedTasks?.length - 1 ? prev + 1 : 0));
    };

    // Don't render if no tasks
    if (!sortedTasks?.length) {
        return <Typography textAlign="center">No pending tasks</Typography>;
    }

    return (
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <CommonFeatureIcon
                icon={<ArrowBackIosNew sx={{ fontSize: '16px' }} />}
                background="white"
                height="35px"
                width="35px"
                color="gray"
                handleClick={handlePrev}
                sx={{ cursor: 'pointer' }}
            />

            <Box display="flex" flexDirection="column" alignItems="center">
                <Typography>Pending Tasks</Typography>
                <Typography fontSize={22} color={theme.palette.secondary.main} fontWeight={600}>
                    {moment(currentTask.due_date).format('MMM DD')}
                </Typography>
                <Typography>{currentTask.title}</Typography>
            </Box>

           <CommonFeatureIcon
                    icon={<ArrowForwardIos sx={{ fontSize: '16px' }} />}
                    background="white"
                    height="35px"
                    width="35px"
                    color="gray"
                    handleClick={handleNext}
                    sx={{ cursor: 'pointer' }}
                />
        </Box>
    );
}

export default TaskCarousel;